<template>
    <v-dialog v-model="modalquestions" max-width="600" max-height="98%" style="background:white">
        <v-card>
            <v-layout justify-center>
                <label class="fas fa-question-circle" style="font-size:150px"></label>
            </v-layout> 
            <v-layout justify-center>
                <h2>Escriba su pregunta o duda</h2>
            </v-layout>
            <v-layout justify-center>
                <v-flex xs11>
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                    >
                        <v-text-field
                        :rules="nameRules"
                        label="Nombres"
                        required
                        v-model="questionsusers.name"
                        ></v-text-field>

                        <v-text-field
                        v-model="questionsusers.email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                        ></v-text-field>

                        <v-textarea
                        solo
                        v-model="questionsusers.comment"
                        name="input-7-4"
                        :rules="comentRules"
                        label="Escriba su pregunta"
                        ></v-textarea>
                        <v-layout justify-center>
                            <v-btn
                            :disabled="!valid"
                            color="#11679a"
                            style="color:white"
                            @click="validate"
                            >
                            Enviar
                            </v-btn>
                        </v-layout>

                        
                    </v-form>
                </v-flex>
            </v-layout>
        </v-card>
    </v-dialog>
</template>
<script>
//Event Bus
import { EventBus } from '../../../helpers/eventbus/event-bus'
import questionsusers from '../../../models/questionusers'

const alertify = require('alertifyjs')

export default {
    data: () => ({
      valid: true,
      modalquestions: false,
      questionsusers : new questionsusers(),
      name: '',
      nameRules: [
        v => !!v || 'Nombre es necesario'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail es necesario',
        v => /.+@.+/.test(v) || 'E-mail no válido'
      ],
      comentRules: [
        v => !!v || 'No olvide escribir su comentario'
      ]
    }),

    mounted(){
        EventBus.$on('openmodalquestions', () => {
            this.openmodalquestions()
        })
    },

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          this.axios.post('questionsusers/save',this.questionsusers)
            .then(()=>{
                alertify.success('Pregunta Enviada')
                this.questionsusers = new questionsusers()
            })
            .catch(()=>{
                alertify.error('Error')
            })
        }
      },

      openmodalquestions(){
          this.modalquestions = true
      }
    }
}
</script>

